import { createBrowserRouter } from 'react-router-dom';

// eslint-disable-next-line import/no-unresolved
import BonusExpenditureViewListPage from 'pages/BonusExpenditureViewList';
import DetailCouncilPage from 'pages/DetailCouncilPage';
import C404 from 'components/404';
import CompareVersionPage from 'pages/CompareVersion';
import CompletedProjectProposalListPage from 'pages/CompletedProjectProposalList';
import CreateCouncilPage from 'pages/CreateCouncil';
import CreateCouncilForManyProjectProposalPage from 'pages/CreateCouncilForManyProjectProposal';
import DashboardPage from 'pages/Dashboard';
import EditCouncilPage from 'pages/EditCouncil';
import EmployeeViewListPage from 'pages/EmployeeViewList';
import ForgotPasswordPage from 'pages/ForgotPassword';
import GoogleAuthCallbackPage from 'pages/GoogleAuthCallback';
import LoginPage from 'pages/Login';
import OrganizationViewListPage from 'pages/OrganizationViewList';
import ProgramViewListPage from 'pages/ProgramViewList';
import ResearchFieldViewListPage from 'pages/ResearchFieldViewList';
import ResearchKpiGroupViewListPage from 'pages/ResearchKpiGroupViewList';
import ResetPasswordPage from 'pages/ResetPassword';
import ReviseProjectProposalDetailPage from 'pages/ReviseProjectProposalDetail';
import ReviseProjectProposalViewListPage from 'pages/ReviseProjectProposalViewList';
import RevisePubProjectProposalViewListPage from 'pages/RevisePubProjectProposalViewList';
import SubmitProjectProposalViewListPage from 'pages/SubmitProjectProposalViewList';
import UpdatePasswordPage from 'pages/UpdatePassword';
import UserProfilePage from 'pages/UserProfile';
import VerifyAccountPage from 'pages/VerifyAccount';
import StatisticsPage from 'pages/Statistics';
import CreateContractPage from 'pages/CreateContract';
import DetailContractPage from 'pages/DetailContract';
import EditFinancialAdjustmentPage from 'pages/EditFinancialAdjustment';
import SubmitProjectProposalDetailPage from 'pages/SubmitProjectProposalDetail';
import SubmitProjectProposalMidtermPage from 'pages/SubmitProjectProposalMidterm';
import SubmitProjectProposalAcceptancePage from 'pages/SubmitProjectProposalAcceptance';
import AcceptanceReviewDetailM08Page from 'pages/AcceptanceReviewDetailM08';
import AcceptanceReviewFormCreatePage from 'pages/AcceptanceReviewFormCreate';
import AcceptanceReviewFormEditPage from 'pages/AcceptanceReviewFormEdit';
import MidtermreviewDetailM06Page from 'pages/MidtermreviewDetailM06Page';
import MidtermReviewFormCreatePage from 'pages/MidtermReviewFormCreatePage';
import MidtermReviewFormEditPage from 'pages/MidtermReviewFormEditPage';
import SpecializeReviewDetailPage from 'pages/SpecializeReviewDetail';
import SpecializeReviewFormCreatePage from 'pages/SpecializeReviewFormCreate';
import SpecializeReviewFormEditPage from 'pages/SpecializeReviewFormEdit';
import FinancialReviewDetailPage from 'pages/FinancialReviewDetail';
import FinancialReviewFormCreatePage from 'pages/FinancialReviewFormCreate';
import FinancialReviewFormEditPage from 'pages/FinancialReviewFormEdit';
import CouncilViewListPage from 'pages/CouncilViewList';
import EditCouncilForManyProjectProposalPage from 'pages/EditCouncilForManyProjectProposal';
import PrequalificationReviewFormCreatePage from 'pages/PrequalificationReviewFormCreate';
import PrequalificationReviewDetailPage from 'pages/PrequalificationReviewDetail';
import PrequalificationReviewFormEditPage from 'pages/PrequalificationReviewFormEdit';
import ReviewTheProposalPage from 'pages/ReviewTheProposal';
import CreateCheckResultPage from 'pages/CreateCheckResult';
import EditCheckResultPage from 'pages/EditCheckResult';
import DetailCheckResultPage from 'pages/DetailCheckResult';
import ExtendImplementationTimeDetailPage from 'pages/ExtendImplementationTimeDetail';
import LiquidationAgreementPage from 'pages/LiquidationAgreement';

import RevisePubProjectProposalDetail from 'pages/RevisePubProjectProposalDetail';
import SubmitProjectProposalSumUpPage from 'pages/SubmitProjectProposalSumUp';
import EditLiquidationAgreementPage from 'pages/EditLiquidationAgreement';
import DetailLiquidationAgreementPage from 'pages/DetailLiquidationAgreement';
import EditHumanResourcePage from 'pages/EditHumanResource';
import SubmitProjectProposalLiquidationPage from 'pages/SubmitProjectProposalLiquidation';
import ProgramProposalViewListPage from 'pages/ProgramProposalViewList';

import ProposalViewListPage from 'pages/ProposalViewList';
import DetailProposalPage from 'pages/DetailProposal';
import CreateProposalPage from 'pages/CreateProposal';
import EditProposalPage from 'pages/EditProposal';
import Unauthorized from 'components/Unauthorized';
import CataloguePage from 'pages/Catalogue';
import ProjectAdjustmentViewListPage from 'pages/ProjectAdjustmentViewList';
import LiquidationReviewDetailPage from 'pages/LiquidationReviewDetail';
import LiquidationReviewCreateEditPage from 'pages/LiquidationReviewCreateEdit';
import RegisterResultCheckerPage from 'pages/RegisterResultChecker';

export default createBrowserRouter(
  [
    {
      path: '/',
      element: <DashboardPage />,
    },
    {
      path: '/login',
      element: <LoginPage />,
    },
    {
      path: '/update-password',
      element: <UpdatePasswordPage />,
    },
    {
      path: '/reset-password',
      element: <ResetPasswordPage />,
    },
    {
      path: '/forgot-password',
      element: <ForgotPasswordPage />,
    },
    {
      path: '/auth/confirm',
      element: <VerifyAccountPage />,
    },
    {
      path: '/auth/google/callback',
      element: <GoogleAuthCallbackPage />,
    },
    {
      path: '/projects-submit',
      children: [
        {
          index: true,
          element: <SubmitProjectProposalViewListPage />,
        },
        {
          path: ':projectProposalId',
          children: [
            {
              index: true,
              element: <ReviewTheProposalPage />,
            },
            {
              path: 'compare-version',
              element: <CompareVersionPage />,
            },
            {
              path: 'council',
              children: [
                {
                  path: ':councilId',
                  children: [
                    {
                      path: 'prequalification-review',
                      children: [
                        {
                          path: 'detail',
                          element: <PrequalificationReviewDetailPage />,
                        },
                      ],
                    },
                    {
                      path: 'specialize-review',
                      children: [
                        {
                          path: 'detail',
                          element: <SpecializeReviewDetailPage />,
                        },
                      ],
                    },
                    {
                      path: 'financial-review',
                      children: [
                        {
                          path: 'detail',
                          element: <FinancialReviewDetailPage />,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          path: ':projectId',
          children: [
            {
              index: true,
              element: <SubmitProjectProposalDetailPage />,
            },
            {
              path: ':projectProposalId',
              children: [
                {
                  path: ':summaryReportId',
                  children: [
                    {
                      path: 'midterm-document',
                      children: [
                        {
                          index: true,
                          element: <SubmitProjectProposalMidtermPage />,
                        },
                        {
                          path: 'midterm-review',
                          children: [
                            {
                              path: 'create',
                              element: <MidtermReviewFormCreatePage />,
                            },
                            {
                              path: 'edit',
                              element: <MidtermReviewFormEditPage />,
                            },
                            {
                              path: 'detail',
                              element: <MidtermreviewDetailM06Page />,
                            },
                          ],
                        },
                      ],
                    },
                    {
                      path: 'acceptance-document',
                      children: [
                        {
                          index: true,
                          element: <SubmitProjectProposalAcceptancePage />,
                        },
                        {
                          path: 'acceptance-review',
                          children: [
                            {
                              path: 'detail-m08',
                              element: <AcceptanceReviewDetailM08Page />,
                            },
                            {
                              path: 'create',
                              element: <AcceptanceReviewFormCreatePage />,
                            },
                            {
                              path: 'edit',
                              element: <AcceptanceReviewFormEditPage />,
                            },
                          ],
                        },
                      ],
                    },
                    {
                      path: 'liquidation-document',
                      children: [
                        {
                          index: true,
                          element: <SubmitProjectProposalLiquidationPage />,
                        },
                        {
                          path: 'liquidation-review',
                          children: [
                            {
                              path: 'detail',
                              element: <LiquidationReviewDetailPage />,
                            },
                            {
                              path: 'create',
                              element: <LiquidationReviewCreateEditPage />,
                            },
                            {
                              path: 'edit',
                              element: <LiquidationReviewCreateEditPage />,
                            },
                          ],
                        },
                      ],
                    },
                    {
                      path: 'council',
                      children: [
                        {
                          path: 'create/:councilTypeId',
                          element: <CreateCouncilPage />,
                        },
                        {
                          path: 'edit/:councilId/:councilTypeId',
                          element: <EditCouncilPage />,
                        },
                      ],
                    },
                  ],
                },
                {
                  path: 'sum-up',
                  element: <SubmitProjectProposalSumUpPage />,
                },
                {
                  path: 'liquidation-council',
                  element: <SubmitProjectProposalLiquidationPage />,
                },
                {
                  path: 'council',
                  children: [
                    {
                      path: 'create/:councilTypeId',
                      element: <CreateCouncilPage />,
                    },
                    {
                      path: 'edit/:councilId/:councilTypeId',
                      element: <EditCouncilPage />,
                    },
                  ],
                },
              ],
            },
            {
              path: 'project-adjustment',
              element: <ProjectAdjustmentViewListPage />,
            },
            {
              path: 'register-result-checker',
              element: <RegisterResultCheckerPage />,
            },
            {
              path: 'register-result-checker-liquidation',
              element: <RegisterResultCheckerPage isLiquidation />,
            },
          ],
        },
        {
          path: 'create',
          children: [
            {
              path: ':projectProposalId',
              element: <CreateContractPage />,
            },
            {
              path: 'liquidation/:projectId',
              element: <LiquidationAgreementPage />,
            },
          ],
        },
        {
          path: 'edit',
          children: [
            {
              path: 'liquidation/:projectId',
              element: <EditLiquidationAgreementPage />,
            },
          ],
        },
        {
          path: 'detail',
          children: [
            {
              path: ':projectProposalId',
              element: <DetailContractPage />,
            },
            {
              path: 'liquidation/:projectId',
              element: <DetailLiquidationAgreementPage />,
            },
          ],
        },
        {
          path: 'check-result',
          children: [
            {
              path: 'create/:projectId',
              element: <CreateCheckResultPage />,
            },
            {
              path: 'edit/:projectId',
              element: <EditCheckResultPage />,
            },
            {
              path: 'detail/:projectId',
              element: <DetailCheckResultPage />,
            },
          ],
        },
        {
          path: 'financial-adjustment',
          children: [
            {
              path: ':projectId/:financialAdjustmentId',
              element: <EditFinancialAdjustmentPage readOnly />,
            },
          ],
        },
        {
          path: 'project-deadline-extensions',
          children: [
            {
              path: ':projectId/:projectDeadlineExtensionId',
              element: <ExtendImplementationTimeDetailPage />,
            },
          ],
        },
        {
          path: 'personnel-adjustment',
          children: [
            {
              path: ':projectId/:personnelAdjustmentId',
              element: <EditHumanResourcePage />,
            },
          ],
        },
      ],
    },
    {
      path: '/projects-revise',
      children: [
        {
          index: true,
          element: <ReviseProjectProposalViewListPage />,
        },
        {
          path: ':projectProposalId',
          children: [
            {
              index: true,
              element: <ReviseProjectProposalDetailPage />,
            },
            {
              path: 'council',
              children: [
                {
                  path: 'create/:councilTypeId',
                  element: <CreateCouncilPage />,
                },
                {
                  path: 'edit/:councilId/:councilTypeId',
                  element: <EditCouncilPage />,
                },
                {
                  path: ':councilId',
                  children: [
                    {
                      path: 'prequalification-review',
                      children: [
                        {
                          path: 'detail',
                          element: <PrequalificationReviewDetailPage />,
                        },
                        {
                          path: 'create',
                          element: <PrequalificationReviewFormCreatePage />,
                        },
                        {
                          path: 'edit',
                          element: <PrequalificationReviewFormEditPage />,
                        },
                      ],
                    },
                    {
                      path: 'specialize-review',
                      children: [
                        {
                          path: 'detail',
                          element: <SpecializeReviewDetailPage />,
                        },
                        {
                          path: 'create',
                          element: <SpecializeReviewFormCreatePage />,
                        },
                        {
                          path: 'edit',
                          element: <SpecializeReviewFormEditPage />,
                        },
                      ],
                    },
                    {
                      path: 'financial-review',
                      children: [
                        {
                          path: 'detail',
                          element: <FinancialReviewDetailPage />,
                        },
                        {
                          path: 'create',
                          element: <FinancialReviewFormCreatePage />,
                        },
                        {
                          path: 'edit',
                          element: <FinancialReviewFormEditPage />,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              path: 'compare-version',
              element: <CompareVersionPage />,
            },
          ],
        },
      ],
    },
    {
      path: '/projects-completed',
      children: [
        {
          index: true,
          element: <CompletedProjectProposalListPage />,
        },
        {
          path: ':projectProposalId',
          children: [
            {
              index: true,
              element: <ReviseProjectProposalDetailPage />, // chưa có component này
            },
            {
              path: 'council',
              children: [
                {
                  path: 'create/:councilTypeId',
                  element: <CreateCouncilPage />,
                },
                {
                  path: 'edit/:councilId/:councilTypeId',
                  element: <EditCouncilPage />,
                },
              ],
            },
          ],
        },
        {
          path: 'detail',
          children: [
            {
              path: 'liquidation/:projectId',
              element: <DetailLiquidationAgreementPage />,
            },
          ],
        },
      ],
    },
    {
      path: '/councils',
      children: [
        {
          index: true,
          element: <CouncilViewListPage />,
        },
        {
          path: ':councilId',
          children: [
            {
              index: true,
              element: <DetailCouncilPage />,
            },
          ],
        },
        {
          path: 'create',
          element: <CreateCouncilForManyProjectProposalPage />,
        },
        {
          path: 'edit/:councilId',
          element: <EditCouncilForManyProjectProposalPage />,
        },
      ],
    },
    {
      path: '/proposals',
      children: [
        {
          index: true,
          element: <ProposalViewListPage />,
        },
        {
          path: ':proposalId',
          children: [
            {
              index: true,
              element: <DetailProposalPage />,
            },
          ],
        },
        {
          path: 'create',
          element: <CreateProposalPage />,
        },
        {
          path: 'edit/:proposalId',
          element: <EditProposalPage />,
        },
      ],
    },
    //  for partner project proposal
    {
      path: '/pub-projects-revise',
      children: [
        {
          index: true,
          element: <RevisePubProjectProposalViewListPage />,
        },
        {
          path: ':projectProposalId',
          children: [
            {
              index: true,
              element: <RevisePubProjectProposalDetail />,
            },
            {
              path: 'compare-version',
              element: <CompareVersionPage />,
            },
          ],
        },
      ],
    },

    {
      path: '/me',
      element: <UserProfilePage />,
    },
    {
      path: '/employee',
      element: <EmployeeViewListPage />,
    },
    {
      path: '/program',
      element: <ProgramViewListPage />,
    },
    {
      path: '/program-proposal',
      element: <ProgramProposalViewListPage />,
    },
    {
      path: '/organization',
      element: <OrganizationViewListPage />,
    },
    {
      path: '/research-field',
      element: <ResearchFieldViewListPage />,
    },
    {
      path: '/bonus-expenditure',
      element: <BonusExpenditureViewListPage />,
    },
    {
      path: '/research-kpi-group',
      element: <ResearchKpiGroupViewListPage />,
    },
    {
      path: 'forms',
      element: <CataloguePage />,
    },
    {
      path: '/statistics',
      element: <StatisticsPage />,
    },
    { path: '/unauthorized', element: <Unauthorized /> },
    { path: '*', element: <C404 /> },
  ],
  {
    basename: process.env.PUBLIC_URL,
  }
);
